var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticStyle:{"height":"70px"}}),_c('div',{staticClass:"headertop"},[_c('span',{on:{"click":_vm.toPage}},[_vm._v("沪公网安备11000002000001号")]),_c('span',[_vm._v("沪ICP证030173号")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }